import T from "../../../../components/Typography";
import { YourAccounts } from "./components";
import Button from "../../../../components/Button";
import { useIsMobile } from "../../../../helpers/ui";
import { colors } from "../../../../styles";
import { Card } from "../Account/components";
import { useStoreActions, useStoreState } from "../../../../store";

const SendWarning = () => {
  const transferActions = useStoreActions((actions) => actions.transfer);
  const isMobile = useIsMobile();
  return (
    <div style={{ padding: isMobile ? 0 : "0 50px" }}>
      <T variant="headingSm" sx={{ textAlign: "center" }}>
        Are you sure?
      </T>
      <T variant="mdReg" color={colors.gray_600}>
        Moving money from your TIFIN @Work account may impact your ability to
        hit your savings goal and earn the match.
      </T>
      <Button onClick={() => transferActions.setCurrentStep("SELECT_ACCOUNT")}>
        Continue
      </Button>
    </div>
  );
};

const SelectAccount = () => {
  const transferState = useStoreState((state) => state.transfer);
  const transferActions = useStoreActions((actions) => actions.transfer);

  const showSendWarning =
    transferState.currentStep === "SEND_WARNING" &&
    transferState.direction === "send_money";

  return (
    <Card
      hideStyleOnMobile
      sx={{
        height: "430px",
        minHeight: "430px",
        ...(showSendWarning && {
          alignItems: "center",
          justifyContent: "center",
        }),
      }}
    >
      {showSendWarning ? (
        <SendWarning />
      ) : (
        <div>
          <YourAccounts showTitle={false} buttonWidth="100%" allowSelect />
          <Button
            sx={{ marginTop: "8px" }}
            disabled={!transferState.externalAccount}
            onClick={() =>
              transferActions.setCurrentStep(transferState.nextStep)
            }
          >
            Next
          </Button>
        </div>
      )}
    </Card>
  );
};

export default SelectAccount;
